/* eslint-disable-next-line */
export function getMarketCountries(marketId) {
  let countryNames;
  switch (marketId) {
    case 'dk_da':
      countryNames = ['denmark'];
      break;
    case 'fi_fi':
      countryNames = ['finland'];
      break;
    case 'gb_en':
      countryNames = ['england', 'scotland', 'wales'];
      break;
    default:
      countryNames = [];
  }
  return countryNames;
}

export function getListLang(languages) {
  // eslint-disable-next-line array-callback-return
  languages.map((res) => {
    if (res.lang === process.env.GATSBY_SITE_LANG) {
      languages.sort((x, y) => {
        if (x === res) {
          return -1;
        }
        if (y === res) {
          return 1;
        }
        return 0;
      });
    }
  });
  return languages;
}
